import React from "react";
import { stackList } from "../../data/ProjectData";
import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
function About() {
  return (
    <ContactWrapper id="about">
      <div className="Container">
        <div className="SectionTitle">About Me</div>
        <div className="BigCard">
          <div className="AboutBio">
            Hello! My name is <strong>Sukanta. </strong> 
            I'm a Aspiring Full Stack Developer . Capable of writing code using
            ReactJS,HTML, CSS on the frontend and NodeJS, Express and MongoDB on
            the backend to build single page application. Passionate about
            coding and interested in working in a product based company .
          </div>
          <div className="AboutBio tagline2">
            I have become confident using the following technologies.
          </div>
          <Technologies>
            {stackList.map((stack, index) => (
              <Tech key={index} className="tech">
                <TechImg src={stack.img} alt={stack.name} />
                <TechName>{stack.name}</TechName>
              </Tech>
            ))}
          </Technologies>
          <br/>
          <br/>
          <h5>My Soft Skills are: </h5>
           <strong>|| Communication </strong>  
           <strong>|| Time Management</strong>
           <strong>|| Problem Soving</strong>
           <strong>|| Team Work </strong>
                
        </div>
      </div>
    </ContactWrapper>
  );
}

export default About;
